<template>
  <div id="sCouponReport">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          <el-breadcrumb-item>特殊优免查询报表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="100px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       clearable
                       filterable
                       @change="changeCust"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       placeholder="请选择场库"
                       @change="changePark"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发券开始时间::">
            <el-date-picker v-model="startTime"
                            style="width:200px"
                            type="date"
                            :clearable="false"
                            placeholder="选择发券开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发券结束时间::">
            <el-date-picker v-model="endTime"
                            style="width:200px"
                            :clearable="false"
                            type="date"
                            placeholder="选择发券结束时间">
            </el-date-picker>
          </el-form-item>

        </el-col>
        <el-col :span="24">
          <el-form-item label="用户分组::">
            <el-select v-model="pageSearch.fGroupID"
                       clearable
                       filterable
                       @change="changeGrp"
                       placeholder="请选择用户组"
                       style="width:200px;">
              <el-option v-for="item in groupList"
                         :key="item.fGroupID"
                         :label="item.fGroupName"
                         :value="item.fGroupID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户::">
            <el-select v-model="pageSearch.fUserID"
                       clearable
                       filterable
                       placeholder="请选择用户"
                       style="width:200px;">
              <el-option v-for="item in usrList"
                         :key="item.fUserID"
                         :label="('【'+item.fUserNo+'】'+item.fUserName)"
                         :value="item.fUserID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌号码::">
            <el-input placeholder="请输入车牌号码"
                      v-model="pageSearch.fPlateCode"
                      class="search"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           width="80"
                           label="客户编号">
          </el-table-column>
          <el-table-column prop="fParkName"
                           width="120"
                           label="场库名称">
          </el-table-column>
          <el-table-column prop="fPlateCode"
                           width="100"
                           label="车牌">
          </el-table-column>
          <el-table-column prop="fInTime"
                           width="150"
                           label="进场时间">
          </el-table-column>
          <el-table-column prop="fOutTime"
                           width="150"
                           label="出场时间">
          </el-table-column>
          <el-table-column prop="fTotalSecs"
                           width="100"
                           label="停车时长">
          </el-table-column>
          <el-table-column prop="fCalcAmt"
                           width="100"
                           align="right"
                           label="计费金额">
          </el-table-column>
          <el-table-column prop="fGroupName"
                           width="120"
                           label="用户分组">
          </el-table-column>
          <el-table-column prop="fUserName"
                           width="120"
                           label="用户名称">
          </el-table-column>
          <el-table-column prop="fCouponType"
                           width="120"
                           label="优惠券类型">
          </el-table-column>
          <el-table-column prop="fCouponValue"
                           width="120"
                           label="优惠券值">
          </el-table-column>
          <el-table-column prop="fGetTime"
                           width="150"
                           label="发券时间">
          </el-table-column>
          <el-table-column prop="fUseTime"
                           width="150"
                           label="使用时间">
          </el-table-column>
          <el-table-column prop="fPayAmt"
                           align="right"
                           width="100"
                           label="抵扣金额">
          </el-table-column>
          <el-table-column prop="fPaySecs"
                           width="100"
                           align="right"
                           label="抵扣时间">
          </el-table-column>
          <el-table-column prop="fRemark"
                           label="备注">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="180">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="primary"
                         @click="handleDetail(scope.$index, scope.row)">详情</el-button>
              <el-button size="mini"
                         type="info"
                         @click="handleBusDetail(scope.$index, scope.row)">车辆记录</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <div class="pagination-left"><label>{{statisticsMsg}}</label></div>
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle"
               width="55%"
               top="7vh"
               v-loading="true"
               :visible.sync="dialogVisible"
               v-dialogDrag>
      <el-form label-width="110px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="商户订单号">
              <el-input v-model="form.fBusOrderNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户编号">
              <el-input v-model="form.fCustNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="服务器IP">
              <el-input v-model="form.fSvrIPAddr"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="车辆记录ID">
              <el-input v-model="form.fBusID"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="场库编号">
              <el-input v-model="form.fParkNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="场库名称">
              <el-input v-model="form.fParkName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="进场时间">
              <el-input v-model="form.fInTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="离场时间">
              <el-input v-model="form.fOutTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车牌号">
              <el-input v-model="form.fPlateCode"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="用户分组">
              <el-input v-model="form.fGroupName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户编号">
              <el-input v-model="form.fUserNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户名称">
              <el-input v-model="form.fUserName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="优惠券类型">
              <el-input v-model="form.fCouponType"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优惠值">
              <el-input v-model="form.fCouponValue"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优惠券编码">
              <el-input v-model="form.fCouponCode"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="停车时长">
              <el-input v-model="form.fTotalSecs"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="抵扣时间">
              <el-input v-model="form.fPaySecs"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优惠券状态">
              <el-input v-model="form.fStatus"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="计费金额">
              <el-input v-model="form.fCalcAmt"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="抵扣金额">
              <el-input v-model="form.fPayAmt"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注信息">
              <el-input v-model="form.fRemark"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <carInfoView ref="child"
                 reportActiveName="pageData"
                 :isNeedCustIdSearch="true"
                 :type="2"></carInfoView>
  </div>
</template>

<script>
import carInfoView from '../../components/carInfoView'
import { report as api } from '../../api/report'
import * as park from '../../api/park'
import * as user from '../../api/user'
import $ from 'jquery'
export default {
  name: 'sCouponReport',
  components: { carInfoView },
  data () {
    return {
      statisticsMsg: '',
      cust_list: [],
      groupList: [],
      usrList: [],
      park_list: [],
      dialogVisible: false,
      dialogTitle: '',
      title: '扬子江丽笙酒店报表',
      form: {},
      is_export: false,
      tableHeight: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      pageData: [],
      startTime: '',
      endTime: '',
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fParkID: '',
        fGroupID: '',
        fUserID: '',
        fStartTime: '',
        fEndTime: '',
        fPlateCode: '',
        isExport: 0
      },
      startMonthOption: {
      },
      endMonthOption: {
      }
    }
  },
  methods: {
    handleBusDetail (index, row) {
      this.$refs.child.handleInfo(row)
    },
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd 00:00:00')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd 23:59:59')
      this.pageSearch.isExport = 0
      api.sCouponReportList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          // console.log(res)
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data || []
            this.pageCount = data.Data.count
            this.statisticsMsg = '特殊优免数量合计:' + data.Data.count + ' | 抵扣金额合计:' + data.Data.fPayAmtTotal + ' |  抵扣时间合计:' + data.Data.fPaySecsTotal
          } else {
            this.$message.error('提示：加载特殊优免数据失败')
          }
        }
      })
    },
    changeCust (fCustID) {
      // 加载离场数据列表
      // this.page_list()
      this.pageSearch.fParkID = ''
      this.park_list = []
      this.pageSearch.fGroupID = ''
      this.groupList = []
      this.pageSearch.fUserID = ''
      this.usrList = []

      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
      api.sCouponReportSelectList({ fCustID: fCustID, fType: 1 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.groupList = data.Data
          } else {
            this.$message.error('提示：加载用户分组失败')
          }
        }
      })
      api.sCouponReportSelectList({ fCustID: fCustID, fType: 2 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.usrList = data.Data
          } else {
            this.$message.error('提示：加载用户失败')
          }
        }
      })
    },
    changePark (fParkID) {
      this.pageSearch.fGroupID = ''
      this.groupList = []
      this.pageSearch.fUserID = ''
      this.usrList = []
      api.sCouponReportSelectList({ fCustID: this.pageSearch.fCustID, fParkID: fParkID, fType: 1 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.groupList = data.Data
          } else {
            this.$message.error('提示：加载用户分组失败')
          }
        }
      })
      api.sCouponReportSelectList({ fCustID: this.pageSearch.fCustID, fParkID: fParkID, fType: 2 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.usrList = data.Data
          } else {
            this.$message.error('提示：加载用户失败')
          }
        }
      })
    },
    changeGrp (fGroupID) {
      this.pageSearch.fUserID = ''
      this.usrList = []
      api.sCouponReportSelectList({ fCustID: this.pageSearch.fCustID, fParkID: this.pageSearch.fParkID, fGroupID: fGroupID, fType: 2 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.usrList = data.Data
          } else {
            this.$message.error('提示：加载用户失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    getCurrentMonthLast (dt) {
      var date = dt
      var currentMonth = date.getMonth()
      var nextMonth = ++currentMonth
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
      var oneDay = 1000 * 60 * 60 * 24
      var lastTime = new Date(nextMonthFirstDay - oneDay)
      var month = parseInt(lastTime.getMonth() + 1)
      var day = lastTime.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return new Date(date.getFullYear() + '-' + month + '-' + day)
    },
    selectStartMonth () {
      var endMonth = this.endTime.getMonth()
      var startMonth = this.startTime.getMonth()
      if (endMonth !== startMonth) {
        this.endTime = this.getCurrentMonthLast(this.startTime)
      }
      this.endMonthOption = {
        disabledDate: (time) => {
          if (this.startTime !== '') {
            var endMonth = this.startTime.getMonth()
            var minMonth = time.getMonth()
            return time.getTime() < this.startTime.getTime() || minMonth !== endMonth
          }
        }
      }
    },
    selectEndMonth () {
      // var endMonth = this.endTime.getMonth()
      // var startMonth = this.startTime.getMonth()
      // if (endMonth !== startMonth) {
      //   this.startTime = new Date(this.endTime.getFullYear(), this.endTime.getMonth(), 1, 0, 0, 0)
      // }
      // this.startMonthOption = {
      //   disabledDate: (time) => {
      //     if (this.endTime !== '') {
      //       var endMonth = this.endTime.getMonth()
      //       var minMonth = time.getMonth()
      //       return time.getTime() > this.endTime.getTime() || endMonth > minMonth
      //     }
      //   }
      // }
    },
    exportData () {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd 00:00:00')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd 23:59:59')
      this.pageSearch.isExport = 1
      this.export_loading = true
      this.export_msg = '导出中……'
      var fileName = '所有客户'
      if ((this.pageSearch.fCustID || '').trim().length > 0) {
        var custArr = (this.cust_list || []).filter((item) => {
          return item.fCustID === this.pageSearch.fCustID
        })
        fileName = custArr.length > 0 ? custArr[0].unionName : ''
      }
      api.sCouponReportList(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_特殊优免查询报表.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    init () {
      // var firstDay = new Date()
      // firstDay.setDate(1)
      // this.startTime = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate(), 0, 0, 0)
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            if (this.cust_list && this.cust_list.length === 1) {
              this.pageSearch.fCustID = this.cust_list[0].fCustID
              this.changeCust(this.pageSearch.fCustID)
            }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })

      user.getCurrentUserPers({ perTypeId: 1017000 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.is_export = data.Data.data.is_export
            }
          } else {
            this.$message.error('提示：加载当前用户权限信息失败')
          }
        }
      })
    },
    handleDetail (index, row) {
      this.form = row
      this.dialogTitle = '【' + row.fCustNo + '】' + row.fParkName + '-优惠券详情'
      this.dialogVisible = true
    },
    setImgHeight () {
      var formHeight = $('.form_right').height()
      var fplateHeight = $('.fplate_info .el-image').height()
      var carImgHeight = $('.car_img .img').height()
      if (formHeight && fplateHeight > 0) {
        var height = (formHeight - fplateHeight - carImgHeight) / 2
        $('.fplate_info').css({ 'margin-top': height + 'px', 'margin-bottom': height + 'px' })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 255
      obj.tableHeight = clientHeight
    }
  },
  created () {
    this.init()
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style >
/* dialog弹出框样式 */
#sCouponReport .el-dialog {
  min-width: 840px;
}
#sCouponReport .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#sCouponReport .el-dialog__title {
  color: white;
}
#sCouponReport .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#sCouponReport .el-dialog__body {
  padding: 3px 10px;
  font-size: 13px;
  /* font-family: "宋体"; */
}
#sCouponReport .fRemark > .el-textarea__inner {
  height: 100px;
}
#sCouponReport .fRemark_row .el-form-item__content {
  height: 100px;
}
#sCouponReport .fRemark_big > .el-textarea__inner {
  height: 135px;
}
#sCouponReport .fRemark_row_big .el-form-item__content {
  height: 135px;
}
#sCouponReport .el-input.is-disabled .el-input__inner,
#sCouponReport .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
</style>
<style scoped>
.pagination-left {
  float: left;
  font-size: 13px;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
  line-height: 28px;
  height: 28px;
}
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.danger {
  color: #f56c6c;
}
.success {
  color: #67c23a;
}
</style>



// WEBPACK FOOTER //
// src/view/report/sCouponReport.vue